export enum InformationTypeEnum {
  Option = 1,
  CustomerObservation = 2,
}
